export function calcDefaultCusto(
  station: { contrato?: string; tipoConector?: string } | undefined,
): number | null {
  if (!station?.contrato) return null;
  if (station.contrato === 'P&D') return 500;
  if (station.tipoConector === 'DC') return 1500;
  if (station.tipoConector === 'AC') return 1000;
  return null;
}
